<template>
    <h1>
        <auggie-icon class="mb-2"/>
        Session {{ auggieDeviceName }} {{ sessionType }}
    </h1>
</template>

<style scoped lang="scss">
    h1 svg {
        width: 2.25rem;
        height: 2rem;
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";
import { Global } from "@/support/GlobalData";
import { SessionType } from "@/shared/enums/SessionType";

export default defineComponent({
    computed: {
        auggieDeviceName(): string {
            if (!Global.CalibrationSession || !Global.CalibrationSession.DeviceName) return "";
            return ` - ${Global.CalibrationSession.DeviceName}`;
        },
        sessionType(): string {
            if (Global.CalibrationSession?.SessionType === SessionType.AssistedCalibration) return " - Assisted Calibration";
            if (Global.CalibrationSession?.SessionType === SessionType.AssistedTargetDisplay) return " - Target Request";
            return "";
        },
    },
});
</script>
